import { FormattedMessage, useIntl } from 'react-intl';

import { SearchableDropdownField } from 'ui-components/components/dropdown';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { Text, TextType } from 'ui-components/components/text';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import { useAdvancedShippingNoticeContext } from '../../../../advanced-shipping-notice-context';
import styles from '../define-shipments-table.module.less';
import { messages } from '../messages';

const ItemInformationCell = ({ row, getOptionsForDropdown, onSelectProduct, getDisabledOptionsForDropdown, isReadOnly }) => {
  const { isParcelConfiguration } = useAdvancedShippingNoticeContext();
  const intl = useIntl();
  const { isHeader, boxNumber, boxConfigurationId, productId, uniqueProductRowId } = row?.original || {};

  const availableOptions = getOptionsForDropdown(boxConfigurationId);
  const selectedOption = availableOptions.find((option) => option.value === productId);

  if (isReadOnly) {
    return <Text textType={TextType.Paragraph} value={selectedOption?.name} />;
  }

  const disabledValues = getDisabledOptionsForDropdown(boxConfigurationId);

  const handleSelectProduct = (selectedProductId) => {
    onSelectProduct({
      productId: selectedProductId,
      boxConfigurationId,
      uniqueProductRowId,
    });
  };

  if (isHeader) {
    return (
      <Text
        formattedMessageValues={{ index: boxNumber }}
        textType={TextType.Label}
        value={isParcelConfiguration ? messages.itemInformationBoxLabel : messages.itemInformationPalletLabel}
      />
    );
  }

  const renderOption = (option) => (
    <div className={styles['product-option']}>
      <Text textType={TextType.Label} value={option.name} />
      <Text textType={TextType.Caption} value={option.sku} />
    </div>
  );

  const dropdownOptions = availableOptions.map(({ value, text, name, sku }) => ({
    value,
    label: text,
    name,
    sku,
    disabled: disabledValues.includes(value),
  }));

  return (
    <Tooltip openDelayMs={500}>
      <div className={styles['select-product-dropdown']}>
        <SearchableDropdownField
          getOptionIsDisabled={(option) => option.disabled}
          onItemSelected={handleSelectProduct}
          options={dropdownOptions}
          placeholder={intl.formatMessage(messages.selectProductPlaceholder)}
          renderOption={renderOption}
          renderSelectedValue={(option) => option.name}
          selectedItemValue={productId || ''}
        />
      </div>
      {!!selectedOption?.name && <TooltipContent>{selectedOption.name}</TooltipContent>}
    </Tooltip>
  );
};

export const createItemInformationColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'name',
  Header: <FormattedMessage {...messages.itemInformationColumnHeader} />,
  Cell: ItemInformationCell,
  width: 2,
});
